import { HelpCircle } from 'lucide-react';

import { HOME_FAQS } from '../data/homeFaqs';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FaqSection = ({ faqs = HOME_FAQS }) => {
  return (
    <section
      id="faq"
      className="py-20 bg-white"
      aria-labelledby="faq-heading"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <HelpCircle className="h-8 w-8 text-red-600" />
          </div>
          <h2
            id="faq-heading"
            className="text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4"
          >
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Common questions from new students and parents — answered honestly.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="border-b border-gray-200"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-red-600 hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-gray-600 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <p className="text-center text-gray-600 mt-10">
          Have a question we didn't cover?{' '}
          <a
            href="#contact"
            className="text-red-600 font-semibold hover:underline"
          >
            Reach out
          </a>{' '}
          and we'll get back to you.
        </p>
      </div>
    </section>
  );
};

export default FaqSection;
